.container {
  background-color: #212121;
  display: flex;
  width: 15vw;
  height: 100%;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  border-color: #444444;
}

.treeStyle {
  margin-left: 10px;
  margin-top: 10px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: rgb(243, 239, 251);
  font-size: 12px;
  font-weight: 100;
  text-decoration: none;
}

.iconPoiStyle {
  padding-right: 3px;
  width: 16px;
}
.iconBackgroundSoundStyle {
  padding-right: 3px;
  width: 14px;
}
.iconFocusedSoundStyle {
  padding-right: 3px;
  width: 14px;
}
.iconRouteLineStyle {
  padding-right: 3px;
  width: 14px;
}
.iconRoutePropertiesStyle {
  padding-right: 3px;
  width: 14px;
}
.selectedStyle {
  font-weight: bold;
  color: #ff7917;
  cursor: pointer;
}
.unselectedStyle {
  font-weight: lighter;
  color: white;
  cursor: pointer;
}
